import { AuthenticationAssuranceLevel, ScopeType, AuditPolicy, IdempotencyPolicy, ConcurrencyPolicy, PrivacyClassification, ActorType, } from './operation.js';
export const PORTFOLIO_CUSTODY_EVIDENCE_LIST = 'investment.custody-evidence.list';
export const CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN = 'client.custody-evidence.read-own';
export const PORTFOLIO_CUSTODY_OPERATIONS = {
    [PORTFOLIO_CUSTODY_EVIDENCE_LIST]: {
        id: PORTFOLIO_CUSTODY_EVIDENCE_LIST,
        name: 'List Portfolio Custody Evidence',
        labelKey: 'operations.portfolioCustody.list.label',
        descriptionKey: 'operations.portfolioCustody.list.description',
        permission: 'organization:reports:read',
        permissionId: 'organization:reports:read',
        module: 'INVESTMENT',
        requiredModules: ['INVESTMENT', 'REPORTING'],
        requiresEntitledModule: true,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [
            ScopeType.ORGANIZATION,
            ScopeType.BRANCH,
            ScopeType.CLIENT,
            ScopeType.PORTFOLIO,
        ],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH', 'CLIENT', 'PORTFOLIO'],
        allowedPersonas: ['ORG_ADMIN', 'ORG_USER'],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        requestedScope: {
            branchId: [{ source: 'query', field: 'branchId' }],
            clientAccountId: [{ source: 'query', field: 'filters.clientAccountId' }],
            portfolioId: [{ source: 'query', field: 'filters.portfolioAccountId' }],
        },
        forcesClientScope: true,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'portfolio.custody-evidence.list',
        allowedActorTypes: [ActorType.USER, ActorType.SUPPORT_DELEGATE],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: true,
        supportDelegationEligible: true,
        delegationPolicy: 'EXPLICITLY_GRANTED',
        accessType: 'READ',
    },
    [CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN]: {
        id: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN,
        name: 'Read Own Portfolio Custody Evidence',
        labelKey: 'operations.portfolioCustody.clientReadOwn.label',
        descriptionKey: 'operations.portfolioCustody.clientReadOwn.description',
        permission: 'client:reports:read-own',
        permissionId: 'client:reports:read-own',
        module: 'INVESTMENT',
        requiredModules: ['INVESTMENT', 'REPORTING'],
        requiresEntitledModule: true,
        requiredAal: AuthenticationAssuranceLevel.AAL1,
        scopeTypes: [ScopeType.CLIENT, ScopeType.PORTFOLIO],
        allowedScopeKinds: ['CLIENT', 'PORTFOLIO'],
        allowedPersonas: ['ORG_CLIENT'],
        ownershipPolicy: 'OWN_CLIENT',
        clientForcing: 'REQUIRED',
        requestedScope: {
            portfolioId: [{ source: 'query', field: 'filters.portfolioAccountId' }],
        },
        forcesClientScope: true,
        makerCheckerRequired: false,
        idempotencyPolicy: IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: ConcurrencyPolicy.NONE,
        auditPolicy: AuditPolicy.READ,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: 'portfolio.custody-evidence.client.read-own',
        allowedActorTypes: [ActorType.CLIENT],
        httpMethods: ['GET'],
        isReadOnly: true,
        isFinancial: true,
        supportDelegationEligible: false,
        delegationPolicy: 'NOT_ALLOWED',
        accessType: 'READ',
    },
};
